import type { ReactNode } from 'react';

/**
 * A section's head: its title, one line saying what it holds, and its actions — at most one of
 * them primary (one primary action per view, Brand Kit § CTA And Buttons). The title is an `h2`,
 * like every screen's: the shell's breadcrumb is the page's one `h1`.
 */
export function PageHead({
  title,
  summary,
  actions,
  titleId,
}: {
  readonly title: string;
  readonly summary?: string;
  readonly actions?: ReactNode;
  readonly titleId?: string;
}) {
  return (
    <div className="page-head">
      <div className="min-w-0">
        <h2 id={titleId} className="screen-title">
          {title}
        </h2>
        {summary !== undefined ? <p className="screen-summary">{summary}</p> : null}
      </div>
      {actions !== undefined ? <div className="page-head-actions">{actions}</div> : null}
    </div>
  );
}
